import { Badge, Avatar } from '@/components/dashboard/kit';

/*
  Piezas comunes de Personas (Resumen, listas y ficha). Una sola definición de las etiquetas y de
  las insignias de estado: nivel, test, etapa y pago. Construidas sobre Badge y Avatar del kit.
*/

export const TIER = {
  free: ['Free', 'neutral'],
  access: ['Access', 'info'],
  pro: ['PRO', 'violet'],
  premium: ['Broker (Premium)', 'gold'],
  admin: ['Admin', 'good'],
  superadmin: ['Superadmin', 'good'],
  sin_cuenta: ['Sin cuenta', 'neutral'],
};
// Rol visible (decisión de Samuel, 14/10/2026): sale de la membresía; admin/superadmin, del equipo
export const TIER_OPTIONS = ['free', 'access', 'pro', 'premium', 'admin', 'superadmin', 'sin_cuenta'];

export const TEMP = { hot: ['Caliente', 'bad'], warm: ['Templado', 'warn'], cold: ['Frío', 'info'] };

// Etapa del test (funnel_leads.status)
export const STAGE = {
  new: 'Nuevo', qualifying: 'Hablando con Freedy', booked: 'Agendó llamada', nurturing: 'En seguimiento',
  won: 'Ganado', lost: 'Perdido',
};
// Filtro de etapa (el servidor agrupa «Nuevo» y «Hablando con Freedy» como «Sin atender»)
export const STAGE_FILTER = [['', 'Todas las etapas'], ['open', 'Sin atender'], ['booked', 'Agendó llamada'],
  ['nurturing', 'En seguimiento'], ['won', 'Ganados'], ['lost', 'Perdidos']];

// Estado de un formulario antiguo de la web (colección leads)
export const WEB_STATUS = { new: 'Nuevo', contacted: 'Contactado', qualified: 'Cualificado', converted: 'Convertido', rejected: 'Descartado' };

// Título de un evento o edición del bootcamp («Bootcamp · …» solo si el título no lo dice ya)
export const eventTitle = (kind, title) => (kind === 'bootcamp' && !/bootcamp/i.test(title || '') ? `Bootcamp · ${title}` : title);
// «1 pendiente», «2 pendientes»
export const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

const PAY_TONE = { paid: 'good', included: 'good', pending: 'warn', free: 'neutral', rejected: 'bad' };

export function TierBadge({ tier }) {
  const [label, tone] = TIER[tier] || TIER.free;
  return <Badge tone={tone}>{label}</Badge>;
}

export function TestBadge({ temperature, score }) {
  const [label, tone] = TEMP[temperature] || ['Hecho', 'neutral'];
  return <Badge tone={tone} title="Test de idoneidad">{`Test · ${label}${score !== null && score !== undefined ? ` ${score}` : ''}`}</Badge>;
}

export function PayBadge({ pay, label }) {
  return <Badge tone={PAY_TONE[pay] || 'neutral'}>{label}</Badge>;
}

// Nombre con su inicial y el email debajo (filas de las listas)
export function PersonCell({ name, email }) {
  return (
    <span className="flex items-center gap-3 min-w-0">
      <Avatar name={name} />
      <span className="min-w-0">
        <span className="block text-white font-medium truncate">{name}</span>
        <span className="block text-xs text-gray-400 truncate">{email}</span>
      </span>
    </span>
  );
}

// Insignias de estado de una persona en una lista
export function PersonChips({ row }) {
  return (
    <span className="flex flex-wrap items-center gap-1.5">
      <TierBadge tier={row.tier} />
      {row.has_test && <TestBadge temperature={row.temperature} score={row.score} />}
      {row.booking_clicked && <Badge tone="good" title="Abrió la agenda para pedir la llamada">Agenda abierta</Badge>}
      {row.registration
        ? <PayBadge pay={row.registration.pay} label={row.registration.pay_label} />
        : row.pending_payments > 0 && <Badge tone="warn">{row.pending_payments === 1 ? '1 pago pendiente' : `${row.pending_payments} pagos pendientes`}</Badge>}
    </span>
  );
}
